<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@ui/lib/utils.js';
import { AvatarRoot } from 'reka-ui';
import { pAvatarVariants, type PAvatarVariants } from '@ui/components/core/p-avatar/index.js';

const props = defineProps<{
    class?: HTMLAttributes['class'];
    variant?: PAvatarVariants['variant'];
    size?: PAvatarVariants['size'];
}>();
</script>

<template>
    <AvatarRoot
        data-slot="avatar"
        :class="cn('relative flex shrink-0 overflow-hidden ', pAvatarVariants({ variant, size }), props.class)"
    >
        <slot />
    </AvatarRoot>
</template>
